import React, { useEffect } from 'react';

import Tabs from '../../shared/Tabs/Tabs';
import TabPanel from '../../shared/Tabs/TabPanel';
import Overview from './JourneyTabs/Overview';

import { useSelector } from 'react-redux';
import Calendar from './JourneyTabs/Calendar';

const Journey = () => {
    const tabs = useSelector((state) => state.appState.missionTabs);
    const activeTab = useSelector((state) => state.appState.activeTab);

    // useEffect(() => {
    //     // props.setTourItem("journey");
    // }, []);

    return (<>
        <Tabs tabs={tabs} activeTab={activeTab} />

        <TabPanel value={activeTab} name="Overview" key="Overview" >
            <Overview />
        </TabPanel>
        <TabPanel value={activeTab} name="Calender" key="Calender" >
            <Calendar />
        </TabPanel>
    </>
    );
};

export default Journey;